import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.blacks.ipBlack8};
  color: ${(props) => props.theme.colors.blacks.ipBlack5};
  border-bottom: 1px solid ${(props) => props.theme.colors.blacks.ipBlack6};

  height: 40px;
  padding: 0px 24px;

  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
`;
